<div class="three-js-container" #threeContainer></div>
